// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/youtube/youtube-video-thumbnail.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullCarousel {
  min-height: 90vh !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100%;
}

.leftCarousel {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.carouselSubTitle {
  color: #f0592a !important;
  font-weight: 400 !important;
  font-size: 2rem;
  text-align: center;
}
@media (max-width: 576px) {
  .carouselSubTitle {
    font-size: 1.6rem !important;
    padding: 0rem 2rem 0rem 2rem;
  }
}

.carouselSideDiv {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.carouselSideDiv .carouselID {
  color: #FFF;
}

.carouselBottomImg {
  cursor: pointer;
}

.ant-progress .ant-progress-inner {
  background-color: #1d1a36;
  border: 2px solid rgba(255, 255, 255, 0.6117647059);
  padding: 5px;
}

.ant-progress.ant-progress-status-success .ant-progress-bg {
  background-color: #f0592a;
}

.ant-progress .ant-progress-success-bg,
.ant-progress .ant-progress-bg {
  background-color: #f0592a;
  transform-origin: left;
  transition: all 0.8s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}

.inline-image {
  height: 2rem;
  vertical-align: middle;
  object-fit: contain;
}

.ocp {
  background: #1d1a36;
  display: flex;
  align-items: center !important;
}

.ocp-center {
  display: flex;
  justify-content: center;
  align-items: center !important;
  height: 100%;
}

.ocp-main-row {
  width: 90vw;
}

.ocp-orange-gradient {
  position: absolute;
  z-index: 1;
  right: 0;
  width: 665px;
  height: 577px;
  border-radius: 665px;
  opacity: 0.5;
  background: rgba(240, 89, 42, 0.4);
  filter: blur(150px);
}

.ocp-logo-div {
  background: #ffffff;
  border-radius: 4rem;
  padding: 5rem 3rem;
  width: 100%;
  z-index: 2;
}

.tab-title {
  color: #000;
  font-size: 3.5vw;
  margin-bottom: 3.3vh;
  text-align: center;
}

.tab-text {
  color: #000;
  font-size: 1.4vw;
  font-weight: 400;
  text-align: center;
  line-height: 150%;
}

.ocp-main-title {
  font-size: 5.1vh;
  font-weight: 700;
  color: #ffffff !important;
}

.cpTabImage {
  min-width: 16vw;
}
@media (max-width: 990px) {
  .cpTabImage {
    min-width: 40vw;
  }
}
@media (max-width: 600px) {
  .cpTabImage {
    min-width: 30vw;
  }
}

@media (max-width: 990px) {
  .ocp-main-title {
    text-align: center;
    font-size: 2.6rem;
  }
  .tab-title {
    font-size: 1.8rem;
    text-align: center;
    padding-right: 0;
    margin-bottom: 12px;
  }
  .tab-text {
    text-align: center;
    font-size: 1.25rem;
  }
  .ocp-logo-div {
    padding: 2rem;
    border-radius: 2rem;
  }
  .ocp-orange-gradient {
    display: none;
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,
  .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {
    max-width: 80vw !important;
    overflow-x: auto !important;
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list::-webkit-scrollbar,
  .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list::-webkit-scrollbar {
    height: 8px;
    background: transparent;
    margin-right: 4px;
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list::-webkit-scrollbar-thumb,
  .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-more,
  .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more {
    display: none;
  }
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {
  max-width: 80vw !important;
  overflow-x: auto !important;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list::-webkit-scrollbar,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list::-webkit-scrollbar {
  height: 0px;
  background: transparent;
  margin-right: 4px;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list::-webkit-scrollbar-thumb,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list::-webkit-scrollbar-thumb {
  border-radius: 8px;
}

.ant-tabs > .ant-tabs-nav .ant-tabs-nav-more,
.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more {
  display: none;
}

.ant-tabs-nav-wrap {
  justify-content: center;
}

.ocp-tab.ant-tabs .ant-tabs-tab + .ant-tabs-tab {
  margin: 0;
}

.ocp-tab .ant-tabs-tab {
  filter: grayscale(100%);
  border-bottom: 2px solid #bab8b8 !important;
  opacity: 0.5;
}

.ocp-tab .ant-tabs-tab-active {
  filter: none;
  opacity: 1;
}

.ocp-tab .ant-tabs-ink-bar::after {
  background: #f0592a !important;
  height: 5px !important;
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

.flag {
  background-color: #f0592a;
  margin-right: 18%;
  position: relative;
  font-weight: 700;
  padding: 20px;
  color: #fff;
}

.flag:before,
.flag:after {
  content: "";
  position: absolute;
  top: 0;
  left: 100%;
  width: 50px;
  height: 50%;
  background-image: linear-gradient(to left top, transparent 50%, #f0592a 50%);
}

.flag:after {
  top: 50%;
  transform: scaleY(-1);
}

.heading-title {
  color: white !important;
}

.infoRow {
  display: flex;
  align-items: center;
  height: 10vh;
  background: #1d1a36;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1411764706);
  overflow: hidden;
}

.infoColImage {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1rem;
}

.menuColStyle {
  background-color: transparent;
  font-size: 1.2rem;
  justify-content: flex-end;
}

.drawerMenuData {
  min-height: 50vh;
  background-color: #010A29;
  padding: 1rem 1rem 2rem 0.5rem;
}

.drawerMenuDataMobile {
  padding: 0rem 1rem 2rem 0.5rem;
}

.headerDrawerData {
  height: 100%;
}

.headerDrawerData h4 {
  color: #eb5a25;
  font-weight: bolder;
  margin-bottom: 1.5rem;
}

.headerDrawerData h5 {
  color: #FFF;
  margin-top: 1rem;
}

.headerDrawerData h6 {
  color: rgb(200, 200, 200);
}

.headerDrawerDataDesktop {
  padding: 1rem;
}

.headerDrawer .ant-drawer-body {
  padding: 0 !important;
}

.headerDrawer h6:hover,
.headerDrawer h5:hover {
  color: #eb5a25;
  cursor: pointer;
}

.ant-menu-submenu-popup {
  color: #FFF !important;
}
.ant-menu-submenu-popup div {
  background-color: #1d1a36 !important;
  color: #FFF !important;
}

.headerMenu {
  color: #eb5a25 !important;
}

/* Underline on hover */
.menuColStyle.ant-menu-horizontal > .ant-menu-submenu:hover::after {
  border-bottom: 2px solid #ffb8b9 !important;
}

/* Underline when submenu is open */
.menuColStyle.ant-menu-horizontal > .ant-menu-submenu-open::after {
  border-bottom: 2px solid #ffb8b9 !important;
}

/* Underline when submenu is selected (child Menu.Item is in selectedKeys) */
.menuColStyle.ant-menu-horizontal > .ant-menu-submenu-selected::after {
  border-bottom: 2px solid #ff4d4f !important;
}

/* Optional transition */
.menuColStyle.ant-menu-horizontal > .ant-menu-submenu::after {
  transition: border-bottom 0.3s ease;
}

.header-custom-tabs .ant-tabs-nav {
  background-color: rgba(255, 255, 255, 0.01);
  height: 100% !important;
  min-height: 50vh;
  min-width: 20vw;
}

.header-custom-tabs .ant-tabs-tab {
  color: white !important;
  transition: all 0.3s;
  font-size: large;
}

.header-custom-tabs .ant-tabs-tab-active {
  border-left: 0.2rem solid #eb5a25;
  border-right: none !important;
  color: #FFF !important;
  background: linear-gradient(90deg, #261729 0%, #261b2f 50%, #272237 100%);
}

/* Remove active tab line */
.header-custom-tabs .ant-tabs-ink-bar {
  display: none !important;
}

.headerDrawerDataDesktop h4 {
  font-weight: 300;
}
.headerDrawerDataDesktop h6 {
  color: #FFF !important;
}
.headerDrawerDataDesktop span {
  color: rgb(200, 200, 200);
  font-weight: 300;
}

/* Base menu item style */
/* When hovered or focused */
.mobile-menu .ant-menu-item-active {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #eb5a25 !important;
  /* Optional hover text color */
}

/* When selected */
.mobile-menu .ant-menu-item-selected {
  color: #eb5a25 !important;
  /* White text */
  background-color: transparent !important;
}

.container-fluid {
  width: 80%;
}

.insights {
  padding: 4rem;
  background: #ffffff;
  width: 50%;
  height: 90vh;
}

.insights-main-row {
  display: flex;
  justify-content: left;
}

.insights-cards {
  margin: 0 !important;
  padding: 0 !important;
}

/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 992px to 1199px
*/
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .insights {
    margin-top: 2rem;
    padding-left: 4rem !important;
    background: #ffffff;
  }
}
/* 
  ##Device = Laptops
  ##Screen = Below 1200px
*/
@media only screen and (min-width: 1200px) {
  .insights {
    margin-top: 2rem;
    padding-left: 4rem !important;
    margin-bottom: 2rem;
    background: #ffffff;
  }
}
/* 
  ##Device = Laptops, Desktops
  ##Screen = abouve 1280px
*/
@media only screen and (min-width: 2560px) {
  .insights {
    margin-top: 2rem;
    padding-left: 4rem !important;
    margin-bottom: 2rem;
    background: #ffffff;
  }
}
@media (max-width: 1070px) {
  .insights {
    height: 120vh;
  }
}
@media (max-width: 768px) {
  .insights {
    height: 150vh;
  }
}
@media (max-width: 585px) {
  .insights {
    height: 200vh;
  }
}
@media (max-width: 375px) {
  .insights {
    height: 220vh;
  }
}
.insightsCard {
  height: 200px;
  width: 400px;
  background: #253C77;
  line-height: 1.2 !important;
  padding: 4% !important;
  border-radius: 0 !important;
}

.insightsCard .ant-card-body {
  padding: 0 !important;
}

.redirectIcon {
  position: absolute;
  top: 85%;
  color: white;
}

.arrow-outlined {
  position: absolute;
  top: 80%;
  color: white;
  outline: solid;
  font-size: 20px;
  padding: 5px;
  cursor: pointer;
}

.insightsCard:hover {
  height: 200px;
  width: 400px;
  background: #3B5085;
  cursor: pointer;
}

.insights-card-text {
  position: relative;
  color: #ffffff;
  padding: 2% 2% !important;
  line-height: 1.2 !important;
}

@media (max-width: 585px) {
  .insightsCard {
    height: 280px;
  }
  .insightsCard:hover {
    height: 280px;
  }
}
.homeButton {
  margin-top: 4%;
}

.homePageIntro {
  margin-bottom: 5rem;
}

.intro-anchor {
  color: #fff;
  text-decoration: none;
}

.youtube-thumbnail {
  width: 100%;
}

.youtube-thumbnail-card {
  display: flex;
  justify-content: center;
  padding: none;
  border: 0;
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  animation: slide-in 0.5s ease-in-out;
}

@keyframes slide-in {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
.youtube-thumbnail-card:hover {
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.19);
  transition: opacity 3s ease-in-out;
  border: 1px solid rgba(0, 0, 0, 0.1411764706);
}

.homePageIntro .overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.popup {
  display: flex;
  justify-content: center;
  position: fixed;
  background-color: rgb(255, 255, 255);
  border-radius: 15px;
  padding: 45px 0 45px 45px;
  top: 50%;
  left: 50%;
  width: 600px;
  height: 450px;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.popupCancelBtn {
  border-radius: 100%;
  border: 1px solid #253c77;
  top: -11%;
  width: 45px;
  height: 45px;
  padding: 0;
}

.popupCancelBtnIcon {
  font-size: 25px;
  color: #253c77;
}

/* 
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/
@media only screen and (min-width: 320px) and (max-width: 479px) {
  .homePageTitle {
    color: #253c77 !important;
  }
  .homePageIntro {
    padding: 2rem 2rem 2rem 2rem;
    min-height: 300px;
    height: auto;
  }
  .numberAnimation {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
  }
  .numberAnimation .fortuneClientStaticText {
    margin-top: 1rem !important;
  }
  .Arrows {
    position: absolute;
    left: 79%;
    top: 25%;
  }
}
/* 
  ##Device = Low Resolution Tablets, Mobiles (Landscape)
  ##Screen = B/w 481px to 767px
*/
@media only screen and (min-width: 480px) and (max-width: 767px) {
  .homePageTitle {
    color: #253c77 !important;
  }
  .homePageIntro {
    padding: 1rem 2rem 1rem 2rem;
    min-height: 300px;
    height: auto;
  }
  .numberAnimation {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
  }
  .numberAnimation .fortuneClientStaticText {
    margin-top: 1rem !important;
  }
  .youtube-thumbnail-card {
    width: 50%;
  }
  .Arrows {
    position: absolute;
    left: 79%;
    top: 25%;
  }
}
/* 
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 991px
*/
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .homePageTitle {
    color: #253c77 !important;
  }
  .homePageIntro {
    padding: 3rem 4rem 3rem 4rem;
    min-height: 300px;
    height: auto;
  }
  .youtube-thumbnail-card {
    width: 50%;
  }
  .numberAnimation {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
  }
  .numberAnimation .fortuneClientStaticText {
    margin-top: 1rem !important;
  }
  .Arrows {
    position: absolute;
    left: 88%;
    top: 25%;
  }
}
/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 992px to 1199px
*/
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .homePageTitle {
    color: #253c77 !important;
  }
  .homePageIntro {
    padding: 3rem 4rem 3rem 4rem;
    min-height: 300px;
    height: auto;
  }
  .numberAnimation {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
  }
  .numberAnimation .fortuneClientStaticText {
    margin-top: 1rem !important;
  }
  .Arrows {
    position: absolute;
    left: 88%;
    top: 25%;
  }
}
/* 
  ##Device = Laptops
  ##Screen = Below 1200px
*/
@media only screen and (min-width: 1200px) {
  .homePageTitle {
    color: #253c77 !important;
  }
  .homePageIntro {
    padding: 4rem 4rem 4rem 4rem;
    min-height: 300px;
    height: auto;
  }
  .numberAnimation {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
  }
  .numberAnimation .fortuneClientStaticText {
    margin-top: 1rem !important;
  }
  .Arrows {
    position: absolute;
    left: 85%;
    top: 25%;
  }
}
/* 
  ##Device = Laptops, Desktops
  ##Screen = abouve 1280px
*/
@media only screen and (min-width: 2560px) {
  .homePageTitle {
    color: #253c77 !important;
  }
  .homePageIntro {
    left: 5%;
    padding: 4rem 4rem 4rem 4rem;
    min-height: 300px;
    height: auto;
  }
  .numberAnimation {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
  }
  .numberAnimation .fortuneClientStaticText {
    margin-top: 1rem !important;
  }
  .Arrows {
    position: absolute;
    left: 88%;
    top: 25%;
  }
}
@media (max-width: 625px) {
  .popup {
    display: flex;
    justify-content: center;
    position: fixed;
    background-color: rgb(255, 255, 255);
    padding: 30px 0 30px 30px;
    top: 50%;
    left: 50%;
    width: 350px;
    height: 250px;
    transform: translate(-50%, -50%);
    z-index: 1000;
  }
  .popupCancelBtn {
    border-radius: 100%;
    border: 1px solid #253c77;
    top: -14%;
    width: 30px;
    height: 30px;
    padding: 0;
  }
  .popupCancelBtnIcon {
    font-size: 25px;
    color: #253c77;
  }
}
@media (max-width: 375px) {
  .popup {
    display: flex;
    justify-content: center;
    position: fixed;
    background-color: rgb(255, 255, 255);
    padding: 30px 0 30px 30px;
    top: 50%;
    left: 50%;
    width: 300px;
    height: 200px;
    transform: translate(-50%, -50%);
    z-index: 1000;
  }
  .popupCancelBtn {
    border-radius: 100%;
    border: 1px solid #253c77;
    top: -14%;
    width: 30px;
    height: 30px;
    padding: 0;
  }
  .popupCancelBtnIcon {
    font-size: 25px;
    color: #253c77;
  }
}
.industries-section {
  background: transparent;
  margin-top: 7.5rem;
}

.industries-main-row {
  width: 100%;
  padding: 0 5rem;
}

.container-industries h2 {
  color: #fff;
  text-align: center;
  font-size: 5.1vh;
  font-weight: 700;
  margin-bottom: 3.75rem;
}

.container-industries h3 {
  color: #fff;
  font-size: 5.1vh;
  font-weight: 400;
  margin-bottom: 1.25rem;
}

.container-industries h4 {
  color: #fff;
  font-size: 1.3vw;
  font-weight: 700;
  margin-bottom: 4rem;
}

.container-industries span {
  color: #fff;
  line-height: 150%;
  font-size: 1.35vw;
}

.industries-industoryBox {
  display: flex;
  justify-content: center;
  margin: 3.75rem 0 7.5rem 0;
  z-index: 2;
}

@media (max-width: 992px) {
  .industries-main-row {
    padding: 0 1rem;
  }
  .container-industries h2 {
    margin-bottom: 1rem;
    font-size: 2.6rem;
  }
  .container-industries h3 {
    font-size: 2.6rem;
  }
  .container-industries h4 {
    text-align: center;
    margin-bottom: 2rem;
    font-size: 1.25rem;
  }
  .container-industries span {
    font-size: 1.125rem;
  }
}
@media (min-width: 1400px) {
  .industory-box {
    width: 20vh;
    height: 20vh;
  }
  .industory-box span {
    text-align: center;
    font-size: 2vh;
  }
}
@media (max-width: 575px) {
  .container-industries h2 {
    font-size: 1.6rem;
  }
  .container-industries h3 {
    font-size: 1.6rem;
  }
  .container-industries span {
    font-size: 1rem;
  }
}
.valueCardText {
  text-align: center;
}

/* 
  ##Device = Laptops, Desktops
  ##Screen = abouve 1280px
*/
@media only screen and (min-width: 2560px) {
  .defaultCard {
    background: #0a2c51 !important;
    min-height: 175px;
    width: 200px;
    height: auto;
    width: auto;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #f0592a;
  }
  .defaultCard:hover {
    background: #253c77 !important;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #fff;
  }
  .rightArrow {
    position: absolute;
    top: 85%;
    left: 90%;
    color: white;
  }
  .serviceIcon {
    height: 50px;
    width: 50px;
  }
  .cardText {
    color: white;
  }
}
/* 
  ##Device = Laptops
  ##Screen = Below 1200px
*/
@media only screen and (min-width: 1200px) {
  .defaultCard {
    background: #0a2c51 !important;
    width: 300px;
    height: 250px;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #f0592a;
    margin-left: 0.2rem;
  }
  .defaultCard:hover {
    background: #253c77 !important;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #fff;
  }
  .rightArrow {
    position: absolute;
    top: 85%;
    left: 90%;
    color: white;
  }
  .serviceIcon {
    height: 50px;
    width: 50px;
  }
  .cardText {
    color: white;
  }
}
/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 992px to 1199px
*/
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .defaultCard {
    background: #0a2c51 !important;
    min-height: 175px;
    width: 200px;
    height: auto;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #f0592a;
  }
  .defaultCard:hover {
    background: #253c77 !important;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #fff;
  }
  .rightArrow {
    position: absolute;
    top: 85%;
    left: 90%;
    color: white;
  }
  .serviceIcon {
    height: 50px;
    width: 50px;
  }
  .cardText {
    color: white;
  }
}
/* 
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 991px
*/
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .defaultCard {
    background: #0a2c51 !important;
    min-height: 175px;
    width: 200px;
    height: auto;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #f0592a;
  }
  .defaultCard:hover {
    background: #253c77 !important;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #fff;
  }
  .rightArrow {
    position: absolute;
    top: 85%;
    left: 90%;
    color: white;
  }
  .serviceIcon {
    height: 50px;
    width: 50px;
  }
  .cardText {
    color: white;
  }
}
/* 
  ##Device = Low Resolution Tablets, Mobiles (Landscape)
  ##Screen = B/w 481px to 767px
*/
@media only screen and (min-width: 480px) and (max-width: 767px) {
  .defaultCard {
    background: #0a2c51 !important;
    min-height: 175px;
    width: 200px;
    height: auto;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #f0592a;
  }
  .defaultCard:hover {
    background: #253c77 !important;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #fff;
  }
  .rightArrow {
    position: absolute;
    top: 85%;
    left: 90%;
    color: white;
  }
  .serviceIcon {
    height: 50px;
    width: 50px;
  }
  .cardText {
    color: white;
  }
}
/* 
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/
@media only screen and (min-width: 320px) and (max-width: 479px) {
  .defaultCard {
    background: #0a2c51 !important;
    min-height: 175px;
    width: 200px;
    height: auto;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #f0592a;
  }
  .defaultCard:hover {
    background: #253c77 !important;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #fff;
  }
  .rightArrow {
    position: absolute;
    top: 85%;
    left: 90%;
    color: white;
  }
  .serviceIcon {
    height: 50px;
    width: 50px;
  }
  .cardText {
    color: white;
  }
}
/* 
      ##Device = Most of the Smartphones Mobiles (Portrait)
      ##Screen = B/w 320px to 479px
    */
@media only screen and (max-width: 320px) {
  .defaultCard {
    background: #0a2c51 !important;
    min-height: 175px;
    width: 200px;
    height: auto;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #f0592a;
  }
  .defaultCard:hover {
    background: #253c77 !important;
    border-radius: 0;
    position: relative;
    border-top: 6px solid #fff;
  }
  .rightArrow {
    position: absolute;
    top: 85%;
    left: 90%;
    color: white;
  }
  .serviceIcon {
    height: 50px;
    width: 50px;
  }
  .cardText {
    color: white;
  }
}
.ourCustomers_div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: #1D1A36;
  padding: 6vw 0vw;
}
.ourCustomers_heading {
  color: #FFF;
  font-family: Roboto;
  font-size: 5.1vh;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  padding-bottom: 3vw;
}
.ourCustomers_card {
  display: flex;
  justify-content: center;
  width: 75vw;
  border-radius: 32.25px;
  padding: 4vw;
  background: linear-gradient(137deg, rgba(255, 182, 160, 0.2) 0%, rgba(240, 89, 42, 0.2) 18.54%, rgba(37, 60, 119, 0.2) 100%);
}
.ourCustomers_img {
  width: 100%;
  justify-content: center;
}
.ourCustomers_col {
  width: 100%;
  display: flex;
  align-self: center;
  justify-content: center;
}

.content {
  width: 100%;
}

.ourCustomersimageDiv {
  height: 30vh;
  justify-content: center;
  align-items: center;
  display: flex;
}

@media only screen and (max-width: 579px) {
  .ourCustomers_heading {
    padding-bottom: 6vw;
    font-size: 5vw;
  }
  .ourCustomers_img {
    width: 50vw;
  }
  .ourCustomers_card {
    padding: 10vw;
    border-radius: 10px;
  }
  .ourCustomers_div {
    padding: 16vw 0vw 0vw;
  }
}
@media only screen and (min-width: 579px) and (max-width: 721px) {
  .ourCustomers_heading {
    font-size: 5vw;
  }
  .ourCustomers_img {
    width: 28vw;
  }
  .ourCustomers_card {
    padding: 10vw;
    width: 80vw;
  }
}
@media only screen and (min-width: 721px) and (max-width: 1388px) {
  .ourCustomers_heading {
    font-size: 5.1vh;
  }
  .ourCustomers_card {
    width: 85vw;
  }
  .ourCustomers_img {
    width: 23vw;
  }
}
@media only screen and (min-width: 1388px) and (max-width: 2561px) {
  .ourCustomers_heading {
    font-size: 5.1vh;
  }
  .ourCustomers_card {
    width: 80vw;
  }
  .ourCustomers_img {
    width: 23vw;
  }
}
.ourPartners_div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: #1d1a36;
  padding: 6vw 0vw;
}
.ourPartners_heading {
  color: #fff;
  font-family: Roboto;
  font-size: 5.1vh;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  padding-bottom: 3.9vw;
}
.ourPartners_card {
  display: flex;
  justify-content: center;
  width: 95vw;
  padding: 4vw 0vw;
  border-radius: 32.25px;
  background: linear-gradient(137deg, rgba(255, 182, 160, 0.2) 0%, rgba(240, 89, 42, 0.2) 18.54%, rgba(37, 60, 119, 0.2) 100%);
}
.ourPartners_col {
  margin: 0vw 2vw;
  width: 100%;
  display: flex;
  align-self: center;
  justify-content: center;
}
.ourPartners_img {
  width: 15vw;
}

@media only screen and (max-width: 601px) {
  .ourPartners_heading {
    padding-bottom: 6vw;
    font-size: 6vw;
  }
  .ourPartners_img {
    width: 50vw;
  }
  .ourPartners_card {
    width: 70vw;
    padding: 10vw;
    border-radius: 10px;
  }
  .ourPartners_div {
    padding: 16vw 0vw 0vw;
  }
}
@media only screen and (min-width: 601px) and (max-width: 721px) {
  .ourPartners_heading {
    font-size: 5vw;
  }
  .ourPartners_img {
    width: 33vw;
  }
  .ourPartners_card {
    width: 80vw;
  }
}
@media only screen and (min-width: 721px) and (max-width: 1026px) {
  .ourPartners_heading {
    font-size: 3.5vw;
  }
  .ourPartners_card {
    padding: 5vw;
    width: 85vw;
  }
  .ourPartners_img {
    width: 23vw;
  }
  .ourPartners_col {
    margin: 0vw 0vw;
  }
  .ourPartners_div {
    padding: 7.8vw 0vw 0vw;
  }
}
@media only screen and (min-width: 1026px) and (max-width: 1388px) {
  .ourPartners_heading {
    font-size: 5.1vh;
  }
  .ourPartners_card {
    padding: 5vw 3vw;
    width: 90vw;
  }
  .ourPartners_img {
    width: 15vw;
  }
  .ourPartners_col {
    margin: 0vw 1vw;
  }
  .ourPartners_div {
    padding: 7.8vw 0vw 0vw;
  }
}
@media only screen and (min-width: 1388px) and (max-width: 1921px) {
  .ourPartners_heading {
    font-size: 5.1vh;
  }
  .ourPartners_col {
    margin: 0vw 1vw;
  }
  .ourPartners_card {
    padding: 3vw 0vw;
    width: 90vw;
  }
  .ourPartners_div {
    padding: 7.8vw 0vw 0vw;
  }
  .ourPartners_img {
    width: 16vw;
  }
}
@media only screen and (min-width: 1921px) and (max-width: 2561px) {
  .ourPartners_heading {
    font-size: 5.1vh;
  }
  .ourPartners_col {
    margin: 0vw 1vw;
  }
  .ourPartners_card {
    padding: 3vw 4vw;
    width: 75vw;
  }
  .ourPartners_img {
    width: 18vw;
  }
  .ourPartners_div {
    padding: 7.8vw 0vw 0vw;
  }
}
.hero_image {
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  margin-bottom: 2rem;
}
.hero_text {
  text-align: center;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 35%;
  left: 50%;
  color: #FFFFFF;
}
.hero_subheading {
  font-family: "Helvetica";
  font-weight: 600;
  font-size: 3vw;
  color: #F0592A;
}
.hero_heading {
  font-weight: bold;
}

@media (min-width: 2100px) {
  .hero_image {
    width: 100%;
    height: 50vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    margin-bottom: 2rem;
  }
  .hero_heading {
    font-size: 4.5rem;
  }
  .hero_subheading {
    font-size: 3.5rem;
  }
}
@media (max-width: 924px) {
  .hero_image {
    width: 100%;
    height: 50vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    margin-bottom: 2rem;
  }
  .hero_heading {
    font-size: 1.6rem;
  }
  .hero_subheading {
    font-size: 1.3rem;
  }
}
.commonListStyle {
  margin-bottom: 1.1vh;
  padding: 0;
  padding-left: 1vw !important;
}
@media (max-width: 1024px) {
  .commonListStyle {
    padding-left: 2.5vw !important;
  }
}

.commonListStyle li {
  line-height: 150%;
}

.commonTitleHead {
  color: #fff;
  font-size: 5.1vh;
  font-weight: 700;
  line-height: 150%;
  z-index: 100;
  margin: 15vh 0 8.4vh 0;
  text-align: center;
}
@media (max-width: 1024px) {
  .commonTitleHead {
    font-size: 2.6rem;
    margin: 8.4vh 0 4.2vh 0;
  }
}
@media (max-width: 575px) {
  .commonTitleHead {
    font-size: 1.6rem;
  }
}

.headingTextMain {
  color: #fff;
  font-size: 5.1vh;
  font-weight: 700;
  line-height: 150%;
}
@media (max-width: 1024px) {
  .headingTextMain {
    font-size: 2.6rem;
  }
}
@media (max-width: 575px) {
  .headingTextMain {
    font-size: 1.6rem;
  }
}

.subHeadTextMain {
  color: #fff;
  font-size: 1.5vw;
  line-height: 150%;
}
@media (max-width: 1024px) {
  .subHeadTextMain {
    font-size: 1.8rem;
  }
}
@media (max-width: 575px) {
  .subHeadTextMain {
    font-size: 1.2rem;
  }
}

.paragraphText {
  color: #fff;
  font-size: 1.6vw;
  width: 100%;
  line-height: 150%;
}
@media (max-width: 1024px) {
  .paragraphText {
    font-size: 1.5rem;
  }
}
@media (max-width: 575px) {
  .paragraphText {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Carousel/carousel.scss","webpack://./src/main.scss","webpack://./src/Sections/HomePage/CustomerAndPartners/customersAndPartners.scss","webpack://./src/Components/Flag/flag.scss","webpack://./src/Components/Layouts/Header/header.scss","webpack://./src/Sections/HomePage/Insights/insights.scss","webpack://./src/Components/InsightsCards/insightsCards.scss","webpack://./src/Sections/HomePage/Intro/intro.scss","webpack://./src/Sections/HomePage/Industries/industries.scss","webpack://./src/Components/Card/serviceCard.scss","webpack://./src/Components/OurCustomer/ourCustomers.scss","webpack://./src/Components/OurPartners/ourPartners.scss","webpack://./src/Components/HerosImages/heroImages.scss"],"names":[],"mappings":"AAAA;EAEE,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;ACAF;;ADGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;ACAF;;ADGA;EACE,yBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;ACAF;ADEE;EANF;IAOI,4BAAA;IACA,4BAAA;ECCF;AACF;;ADEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;ACCF;ADCE;EACE,WAAA;ACCJ;;ADGA;EACE,eAAA;ACAF;;ADwKA;EACE,yBAAA;EACA,mDAAA;EACA,YAAA;ACrKF;;ADwKA;EACE,yBAAA;ACrKF;;ADwKA;;EAEE,yBAAA;EACA,sBAAA;EACA,yDAAA;ACrKF;;ADwKA;EACE,YAAA;EACA,sBAAA;EACA,mBAAA;ACrKF;;AC9DA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;ADiEF;;AC9DA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;ADiEF;;AC9DA;EACE,WAAA;ADiEF;;AC9DA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;ADiEF;;AC9DA;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;ADiEF;;AC9DA;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;ADiEF;;AC9DA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;ADiEF;;AC9DA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;ADiEF;;AC9DA;EACE,eAAA;ADiEF;AChEE;EAFF;IAGI,eAAA;EDmEF;AACF;AClEE;EALF;IAMI,eAAA;EDqEF;AACF;;AClEA;EACE;IACE,kBAAA;IACA,iBAAA;EDqEF;EClEA;IACE,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;EDoEF;ECjEA;IACE,kBAAA;IACA,kBAAA;EDmEF;EChEA;IACE,aAAA;IACA,mBAAA;EDkEF;EC/DA;IACE,aAAA;EDiEF;EC9DA;;IAEE,0BAAA;IACA,2BAAA;EDgEF;EC/DE;;IACE,WAAA;IACA,uBAAA;IACA,iBAAA;EDkEJ;EC/DE;;IACE,8BAAA;IACA,kBAAA;EDkEJ;EC9DA;;IAEE,aAAA;EDgEF;AACF;ACzDA;;EAEE,0BAAA;EACA,2BAAA;AD2DF;AC1DE;;EACE,WAAA;EACA,uBAAA;EACA,iBAAA;AD6DJ;AC1DE;;EAEE,kBAAA;AD4DJ;;ACxDA;;EAEE,aAAA;AD2DF;;ACxDA;EACE,uBAAA;AD2DF;;ACxDA;EACE,SAAA;AD2DF;;ACxDA;EACE,uBAAA;EACA,2CAAA;EACA,YAAA;AD2DF;;ACxDA;EACE,YAAA;EACA,UAAA;AD2DF;;ACxDA;EACE,8BAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AD2DF;;AEnOA;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,aAAA;EACA,WAAA;AFqOF;;AElOA;;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,4EAAA;AFqOF;;AElOA;EACE,QAAA;EACA,qBAAA;AFqOF;;AElOA;EACE,uBAAA;AFqOF;;AGhQA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,oDAAA;EACA,gBAAA;AHmQF;;AGhQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;AHmQF;;AGhQA;EACE,6BAAA;EACA,iBAAA;EACA,yBAAA;AHmQF;;AGhQA;EACE,gBAAA;EACA,yBAAA;EACA,8BAAA;AHmQF;;AGhQA;EACE,8BAAA;AHmQF;;AGhQA;EACE,YAAA;AHmQF;;AGhQA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AHmQF;;AGhQA;EACE,WAAA;EACA,gBAAA;AHmQF;;AGhQA;EACE,yBAAA;AHmQF;;AG9PA;EACE,aAAA;AHiQF;;AG9PA;EACE,qBAAA;AHiQF;;AG9PA;;EAEE,cAAA;EACA,eAAA;AHiQF;;AG7PA;EAME,sBAAA;AH2PF;AGhQE;EACE,oCAAA;EACA,sBAAA;AHkQJ;;AG5PA;EACE,yBAAA;AH+PF;;AG3PA,uBAAA;AACA;EACE,2CAAA;AH8PF;;AG3PA,mCAAA;AACA;EACE,2CAAA;AH8PF;;AG3PA,4EAAA;AACA;EACE,2CAAA;AH8PF;;AG3PA,wBAAA;AACA;EACE,mCAAA;AH8PF;;AG3PA;EACE,2CAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AH8PF;;AG3PA;EACE,uBAAA;EACA,oBAAA;EAEA,gBAAA;AH6PF;;AGzPA;EACE,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,yEAAA;AH4PF;;AGvPA,2BAAA;AACA;EACE,wBAAA;AH0PF;;AGrPE;EACE,gBAAA;AHwPJ;AGrPE;EACE,sBAAA;AHuPJ;AGpPE;EACE,yBAAA;EACA,gBAAA;AHsPJ;;AGjPA,yBAAA;AAMA,4BAAA;AAMA;EACE,qDAAA;EACA,yBAAA;EACA,8BAAA;AH0OF;;AGvOA,kBAAA;AACA;EAEE,yBAAA;EACA,eAAA;EAEA,wCAAA;AHwOF;;AIrZA;EACE,UAAA;AJwZF;;AIrZA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;AJwZF;;AIrZA;EACE,aAAA;EACA,qBAAA;AJwZF;;AIrZA;EACE,oBAAA;EACA,qBAAA;AJwZF;;AA5XI;;;CAAA;AAIA;EI5BF;IACE,gBAAA;IACA,6BAAA;IACA,mBAAA;EJ4ZF;AACF;AA/XI;;;CAAA;AAIA;EI7BF;IACE,gBAAA;IACA,6BAAA;IACA,mBAAA;IACA,mBAAA;EJ+ZF;AACF;AAlYI;;;CAAA;AAIA;EI7BF;IACE,gBAAA;IACA,6BAAA;IACA,mBAAA;IACA,mBAAA;EJkaF;AACF;AI/ZA;EACE;IACE,aAAA;EJiaF;AACF;AI9ZA;EACE;IACE,aAAA;EJgaF;AACF;AI7ZA;EACE;IACE,aAAA;EJ+ZF;AACF;AI5ZA;EACE;IACE,aAAA;EJ8ZF;AACF;AKleA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,2BAAA;ALoeJ;;AKjeA;EACE,qBAAA;ALoeF;;AKjeA;EACI,kBAAA;EACA,QAAA;EACA,YAAA;ALoeJ;;AKjeA;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;ALoeJ;;AKjeA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;ALoeJ;;AKjeA;EACI,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,2BAAA;ALoeJ;;AKjeA;EACI;IACI,aAAA;ELoeN;EKjeE;IACI,aAAA;ELmeN;AACF;AMrhBA;EACE,cAAA;ANuhBF;;AMphBA;EACE,mBAAA;ANuhBF;;AMphBA;EACE,WAAA;EACA,qBAAA;ANuhBF;;AMphBA;EACE,WAAA;ANuhBF;;AMphBA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,yDAAA;EACA,sBAAA;EACA,oCAAA;ANuhBF;;AMphBA;EACE;IACE,4BAAA;ENuhBF;EMrhBA;IACE,wBAAA;ENuhBF;AACF;AMphBA;EACE,6CAAA;EACA,kCAAA;EACA,6CAAA;ANshBF;;AMnhBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;ANshBF;;AMnhBA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,aAAA;ANshBF;;AMnhBA;EACE,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;ANshBF;;AMnhBA;EACE,eAAA;EACA,cAAA;ANshBF;;AAllBI;;;CAAA;AAIA;EM4DF;IACE,yBAAA;EN0hBF;EMvhBA;IACE,4BAAA;IACA,iBAAA;IACA,YAAA;ENyhBF;EMthBA;IACE,gBAAA;IACA,aAAA;IACA,uBAAA;ENwhBF;EMvhBE;IACE,2BAAA;ENyhBJ;EMrhBA;IACE,kBAAA;IACA,SAAA;IACA,QAAA;ENuhBF;AACF;AArmBI;;;CAAA;AAIA;EM8EF;IACE,yBAAA;EN0hBF;EMvhBA;IACE,4BAAA;IACA,iBAAA;IACA,YAAA;ENyhBF;EMthBA;IACE,gBAAA;IACA,aAAA;IACA,uBAAA;ENwhBF;EMvhBE;IACE,2BAAA;ENyhBJ;EMrhBA;IACE,UAAA;ENuhBF;EMphBA;IACE,kBAAA;IACA,SAAA;IACA,QAAA;ENshBF;AACF;AA1nBI;;;CAAA;AAIA;EMoGF;IACE,yBAAA;ENyhBF;EMthBA;IACE,4BAAA;IACA,iBAAA;IACA,YAAA;ENwhBF;EMrhBA;IACE,UAAA;ENuhBF;EMphBA;IACE,gBAAA;IACA,aAAA;IACA,uBAAA;ENshBF;EMrhBE;IACE,2BAAA;ENuhBJ;EMnhBA;IACE,kBAAA;IACA,SAAA;IACA,QAAA;ENqhBF;AACF;AA/oBI;;;CAAA;AAIA;EM0HF;IACE,yBAAA;ENwhBF;EMrhBA;IACE,4BAAA;IACA,iBAAA;IACA,YAAA;ENuhBF;EMphBA;IACE,gBAAA;IACA,aAAA;IACA,uBAAA;ENshBF;EMrhBE;IACE,2BAAA;ENuhBJ;EMnhBA;IACE,kBAAA;IACA,SAAA;IACA,QAAA;ENqhBF;AACF;AAjqBI;;;CAAA;AAIA;EM4IF;IACE,yBAAA;ENwhBF;EMrhBA;IACE,4BAAA;IACA,iBAAA;IACA,YAAA;ENuhBF;EMphBA;IACE,gBAAA;IACA,aAAA;IACA,uBAAA;ENshBF;EMrhBE;IACE,2BAAA;ENuhBJ;EMnhBA;IACE,kBAAA;IACA,SAAA;IACA,QAAA;ENqhBF;AACF;AAnrBI;;;CAAA;AAIA;EM8JF;IACE,yBAAA;ENwhBF;EMrhBA;IACE,QAAA;IACA,4BAAA;IACA,iBAAA;IACA,YAAA;ENuhBF;EMphBA;IACE,gBAAA;IACA,aAAA;IACA,uBAAA;ENshBF;EMrhBE;IACE,2BAAA;ENuhBJ;EMnhBA;IACE,kBAAA;IACA,SAAA;IACA,QAAA;ENqhBF;AACF;AMlhBA;EACE;IACE,aAAA;IACA,uBAAA;IACA,eAAA;IACA,oCAAA;IACA,yBAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;IACA,aAAA;IACA,gCAAA;IACA,aAAA;ENohBF;EMjhBA;IACE,mBAAA;IACA,yBAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;ENmhBF;EMhhBA;IACE,eAAA;IACA,cAAA;ENkhBF;AACF;AM/gBA;EACE;IACE,aAAA;IACA,uBAAA;IACA,eAAA;IACA,oCAAA;IACA,yBAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;IACA,aAAA;IACA,gCAAA;IACA,aAAA;ENihBF;EM9gBA;IACE,mBAAA;IACA,yBAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;ENghBF;EM7gBA;IACE,eAAA;IACA,cAAA;EN+gBF;AACF;AOr0BA;EACE,uBAAA;EACA,kBAAA;APu0BF;;AOp0BA;EACE,WAAA;EACA,eAAA;APu0BF;;AOp0BA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;APu0BF;;AOp0BA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;APu0BF;;AOp0BA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;APu0BF;;AOp0BA;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;APu0BF;;AOp0BA;EACE,aAAA;EACA,uBAAA;EACA,0BAAA;EACA,UAAA;APu0BF;;AOp0BA;EACE;IACE,eAAA;EPu0BF;EOp0BA;IACE,mBAAA;IACA,iBAAA;EPs0BF;EOn0BA;IACE,iBAAA;EPq0BF;EOl0BA;IACE,kBAAA;IACA,mBAAA;IACA,kBAAA;EPo0BF;EOj0BA;IACE,mBAAA;EPm0BF;AACF;AOh0BA;EACE;IACE,WAAA;IACA,YAAA;EPk0BF;EOh0BA;IACE,kBAAA;IACA,cAAA;EPk0BF;AACF;AO/zBA;EACE;IACE,iBAAA;EPi0BF;EO9zBA;IACE,iBAAA;EPg0BF;EO7zBA;IACE,eAAA;EP+zBF;AACF;AQ35BA;EACE,kBAAA;AR65BF;;AA91BI;;;CAAA;AAIA;EQ/DF;IACE,8BAAA;IACA,iBAAA;IACA,YAAA;IACA,YAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,6BAAA;ERi6BF;EQ95BA;IACE,8BAAA;IACA,gBAAA;IACA,kBAAA;IACA,0BAAA;ERg6BF;EQ75BA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;ER+5BF;EQ55BA;IACE,YAAA;IACA,WAAA;ER85BF;EQ35BA;IACE,YAAA;ER65BF;AACF;AA34BI;;;CAAA;AAIA;EQlBF;IACE,8BAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;IACA,kBAAA;IACA,6BAAA;IACA,mBAAA;ERg6BF;EQ75BA;IACE,8BAAA;IACA,gBAAA;IACA,kBAAA;IACA,0BAAA;ER+5BF;EQ55BA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;ER85BF;EQ35BA;IACE,YAAA;IACA,WAAA;ER65BF;EQ15BA;IACE,YAAA;ER45BF;AACF;AAt7BI;;;CAAA;AAIA;EQ0BF;IACE,8BAAA;IACA,iBAAA;IACA,YAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,6BAAA;ER+5BF;EQ55BA;IACE,8BAAA;IACA,gBAAA;IACA,kBAAA;IACA,0BAAA;ER85BF;EQ35BA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;ER65BF;EQ15BA;IACE,YAAA;IACA,WAAA;ER45BF;EQz5BA;IACE,YAAA;ER25BF;AACF;AAj+BI;;;CAAA;AAIA;EQsEF;IACE,8BAAA;IACA,iBAAA;IACA,YAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,6BAAA;ER85BF;EQ35BA;IACE,8BAAA;IACA,gBAAA;IACA,kBAAA;IACA,0BAAA;ER65BF;EQ15BA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;ER45BF;EQz5BA;IACE,YAAA;IACA,WAAA;ER25BF;EQx5BA;IACE,YAAA;ER05BF;AACF;AA5gCI;;;CAAA;AAIA;EQkHF;IACE,8BAAA;IACA,iBAAA;IACA,YAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,6BAAA;ER65BF;EQ15BA;IACE,8BAAA;IACA,gBAAA;IACA,kBAAA;IACA,0BAAA;ER45BF;EQz5BA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;ER25BF;EQx5BA;IACE,YAAA;IACA,WAAA;ER05BF;EQv5BA;IACE,YAAA;ERy5BF;AACF;AAvjCI;;;CAAA;AAIA;EQ8JF;IACE,8BAAA;IACA,iBAAA;IACA,YAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,6BAAA;ER45BF;EQz5BA;IACE,8BAAA;IACA,gBAAA;IACA,kBAAA;IACA,0BAAA;ER25BF;EQx5BA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;ER05BF;EQv5BA;IACE,YAAA;IACA,WAAA;ERy5BF;EQt5BA;IACE,YAAA;ERw5BF;AACF;AAlmCI;;;KAAA;AAIA;EQ0MF;IACE,8BAAA;IACA,iBAAA;IACA,YAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,6BAAA;ER25BF;EQx5BA;IACE,8BAAA;IACA,gBAAA;IACA,kBAAA;IACA,0BAAA;ER05BF;EQv5BA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;ERy5BF;EQt5BA;IACE,YAAA;IACA,WAAA;ERw5BF;EQr5BA;IACE,YAAA;ERu5BF;AACF;AS7oCE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AT+oCJ;AS3oCE;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AT6oCJ;AS1oCE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,4HAAA;AT4oCJ;ASzoCE;EACE,WAAA;EACA,uBAAA;AT2oCJ;ASxoCE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;AT0oCJ;;AStoCA;EACE,WAAA;ATyoCF;;AStoCA;EACE,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;ATyoCF;;AStoCA;EAEI;IACE,mBAAA;IACA,cAAA;ETwoCJ;ESroCE;IACE,WAAA;ETuoCJ;ESroCE;IAAc,aAAA;IACZ,mBAAA;ETwoCJ;EStoCE;IACE,qBAAA;ETwoCJ;AACF;ASnoCA;EAEI;IACE,cAAA;ETooCJ;ESjoCE;IACE,WAAA;ETmoCJ;EShoCE;IACE,aAAA;IACA,WAAA;ETkoCJ;AACF;AS9nCA;EAEI;IACE,gBAAA;ET+nCJ;ES5nCE;IACE,WAAA;ET8nCJ;ES3nCE;IACE,WAAA;ET6nCJ;AACF;AS1nCA;EAEI;IACE,gBAAA;ET2nCJ;ESxnCE;IACE,WAAA;ET0nCJ;ESvnCE;IACE,WAAA;ETynCJ;AACF;AU/uCE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AVivCJ;AU9uCE;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AVgvCJ;AU7uCE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,4HAAA;AV+uCJ;AUxuCE;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;AV0uCJ;AUvuCE;EACE,WAAA;AVyuCJ;;AUtuCA;EAEI;IACE,mBAAA;IACA,cAAA;EVwuCJ;EUruCE;IACE,WAAA;EVuuCJ;EUruCE;IACE,WAAA;IACA,aAAA;IACA,mBAAA;EVuuCJ;EUruCE;IACE,qBAAA;EVuuCJ;AACF;AUluCA;EAEI;IACE,cAAA;EVmuCJ;EUhuCE;IACE,WAAA;EVkuCJ;EU/tCE;IACE,WAAA;EViuCJ;AACF;AU7tCA;EAEI;IACE,gBAAA;EV8tCJ;EU3tCE;IACE,YAAA;IACA,WAAA;EV6tCJ;EU1tCE;IACE,WAAA;EV4tCJ;EU1tCE;IACE,eAAA;EV4tCJ;EU1tCE;IACE,sBAAA;EV4tCJ;AACF;AUxtCA;EAEI;IACE,gBAAA;EVytCJ;EUttCE;IACE,gBAAA;IACA,WAAA;EVwtCJ;EUrtCE;IACE,WAAA;EVutCJ;EUrtCE;IACE,eAAA;EVutCJ;EUrtCE;IACE,sBAAA;EVutCJ;AACF;AUntCA;EAEI;IACE,gBAAA;EVotCJ;EUltCE;IACE,eAAA;EVotCJ;EUltCE;IACE,gBAAA;IACA,WAAA;EVotCJ;EUltCE;IACE,sBAAA;EVotCJ;EUltCE;IACE,WAAA;EVotCJ;AACF;AUjtCA;EAEI;IACE,gBAAA;EVktCJ;EUhtCE;IACE,eAAA;EVktCJ;EUhtCE;IACE,gBAAA;IACA,WAAA;EVktCJ;EU/sCE;IACE,WAAA;EVitCJ;EU/sCE;IACE,sBAAA;EVitCJ;AACF;AWv3CI;EACI,WAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AXy3CR;AWn3CI;EACI,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;AXq3CR;AWj3CI;EACI,wBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AXm3CR;AWh3CI;EACI,iBAAA;AXk3CR;;AW/2CA;EACI;IACI,WAAA;IACA,YAAA;IACA,2BAAA;IACA,4BAAA;IACA,sBAAA;IACA,kBAAA;IACA,mBAAA;EXk3CN;EW/2CE;IACE,iBAAA;EXi3CJ;EW/2CE;IACI,iBAAA;EXi3CN;AACF;AW/2CE;EACE;IACI,WAAA;IACA,YAAA;IACA,2BAAA;IACA,4BAAA;IACA,sBAAA;IACA,kBAAA;IACA,mBAAA;EXi3CN;EW92CE;IACI,iBAAA;EXg3CN;EW72CE;IACI,iBAAA;EX+2CN;AACF;AA51CA;EACE,oBAAA;EACA,UAAA;EACA,4BAAA;AA81CF;AA71CE;EAJF;IAKI,8BAAA;EAg2CF;AACF;;AA71CA;EACE,iBAAA;AAg2CF;;AA71CA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAg2CF;AA/1CE;EARF;IASI,iBAAA;IACA,uBAAA;EAk2CF;AACF;AAj2CE;EAZF;IAaI,iBAAA;EAo2CF;AACF;;AAj2CA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAo2CF;AAn2CE;EALF;IAMI,iBAAA;EAs2CF;AACF;AAr2CE;EARF;IASI,iBAAA;EAw2CF;AACF;;AAr2CA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;AAw2CF;AAv2CE;EAJF;IAKI,iBAAA;EA02CF;AACF;AAz2CE;EAPF;IAQI,iBAAA;EA42CF;AACF;;AAz2CA;EACE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AA42CF;AA12CE;EANF;IAOI,iBAAA;EA62CF;AACF;AA52CE;EATF;IAUI,eAAA;EA+2CF;AACF","sourcesContent":[".fullCarousel {\n  // height: 90vh;\n  min-height: 90vh !important;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 100%;\n}\n\n.leftCarousel {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.carouselSubTitle {\n  color: #f0592a !important;\n  font-weight: 400 !important;\n  font-size: 2rem;\n  text-align: center;\n  // text-transform: uppercase;\n  @media (max-width:576px) {\n    font-size: 1.6rem !important;\n    padding: 0rem 2rem 0rem 2rem;\n  }\n}\n\n.carouselSideDiv {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n\n  .carouselID {\n    color: #FFF;\n  }\n}\n\n.carouselBottomImg{\n  cursor: pointer;\n}\n\n// .carouselBottomDiv{\n//   display: flex;\n//   justify-content: center;\n// }\n\n\n// .carouselBottomDiv{\n//   display: flex;\n//   justify-content: center;\n//   align-items: center;\n//   width: 100%;\n//   border: 1px solid red;\n\n//   .carouselID {\n//     color: #FFF;\n//   }\n// }\n\n\n// .carouselImage {\n//   background-size: cover;\n//   background-repeat: no-repeat;\n//   background-position: 100%;\n//   height: 90vh;\n// }\n\n// .carouselContentRow {\n//   width: 90%;\n// }\n\n// .carouselContentCol {\n//   display: flex;\n//   justify-content: right;\n//   @media (max-width: 767px) {\n//     display: none;\n//   }\n// }\n\n// .carouselHeading {\n//   color: #fff !important;\n//   text-align: center;\n//   font-size: 4.5rem;\n//   font-weight: 700 !important;\n// }\n\n// .carouselHeadingImage {\n//   width: 45vw !important;\n// }\n\n// .carouselSideDivImg {\n//   cursor: pointer;\n//   height: 35vh !important;\n// }\n\n// .carouselSubHeading {\n//   color: #f0592a !important;\n//   font-weight: 400 !important;\n//   font-size: 2vw;\n//   text-align: center;\n//   text-transform: uppercase;\n// }\n\n// .carouselSubHeadingLight {\n//   color: #fff !important;\n//   font-weight: 400 !important;\n//   font-size: 3vw;\n//   text-align: center;\n//   line-height: 100%;\n// }\n\n// .carouselContent {\n//   display: flex;\n//   justify-content: center;\n//   align-items: center !important;\n//   height: 100%;\n// }\n\n// .carouselSideDiv {\n//   position: absolute;\n//   right: 1vw !important;\n//   font-size: 1.5vw;\n//   color: #fff;\n//   font-weight: 500;\n// }\n\n// .carouselBottomDiv {\n//   display: none;\n// }\n\n// .carouselID {\n//   margin: 5vh 0;\n//   margin-left: -0.5vw;\n// }\n\n// @media (max-width: 1200px) {\n//   .carouselImage {\n//     height: 60vw;\n//   }\n// }\n// @media (max-width: 992px) {\n//   .carouselImage {\n//     height: 80vw;\n//   }\n// }\n// @media (max-width: 576px) {\n//   .carouselImage {\n//     height: 150vw;\n//   }\n\n//   .carouselHeadingImage {\n//     width: 90vw !important;\n//   }\n\n//   .carouselSubHeading {\n//     font-size: 1rem !important;\n//   }\n\n//   .carouselSubHeadingLight {\n//     font-size: 1rem !important;\n//   }\n// }\n\n// @media (max-width: 768px) {\n//   .carouselSubHeading {\n//     font-size: 1.5rem !important;\n//     font-weight: 700 !important;\n//     width: 100%;\n//   }\n\n//   .carouselSubHeadingLight {\n//     font-size: 1.5rem !important;\n//     font-weight: 700 !important;\n//     width: 100%;\n//   }\n\n//   .carouselBottomImg {\n//     cursor: pointer;\n//     width: 42vw !important;\n//   }\n\n//   .carouselContentRow {\n//     width: 100%;\n//   }\n\n//   .carouselSideDiv {\n//     display: none;\n//   }\n\n//   .carouselBottomDiv {\n//     display: flex;\n//     width: 100%;\n//     position: absolute;\n//     bottom: -4vh;\n//   }\n\n//   .carouselID {\n//     margin-top: 5vh;\n//     text-align: center;\n//     font-size: 1rem;\n//     color: #fff;\n//     font-weight: 500;\n//     margin-left: 0;\n//   }\n// }\n\n.ant-progress .ant-progress-inner {\n  background-color: #1d1a36;\n  border: 2px solid #ffffff9c;\n  padding: 5px;\n}\n\n.ant-progress.ant-progress-status-success .ant-progress-bg {\n  background-color: #f0592a;\n}\n\n.ant-progress .ant-progress-success-bg,\n.ant-progress .ant-progress-bg {\n  background-color: #f0592a;\n  transform-origin: left;\n  transition: all 0.8s cubic-bezier(0.78, 0.14, 0.15, 0.86);\n}\n\n.inline-image {\n  height: 2rem;\n  vertical-align: middle;\n  object-fit: contain;\n}","$xxs: \"double extra-small\";\n$xs: \"extra-small\";\n$sm: \"small\";\n$md: \"medium\";\n$lg: \"large\";\n$xl: \"extra-large\";\n$xxl: \"double etra large\";\n\n@mixin respond($breakpoint) {\n  @if ($breakpoint == $xxs) {\n    /* \n          ##Device = Most of the Smartphones Mobiles (Portrait)\n          ##Screen = B/w 320px to 479px\n        */\n    @media only screen and (max-width: 320px) {\n      @content;\n    }\n  }\n  @if ($breakpoint == $xs) {\n    /* \n    ##Device = Most of the Smartphones Mobiles (Portrait)\n    ##Screen = B/w 320px to 479px\n  */\n    @media only screen and (min-width: 320px) and (max-width: 479px) {\n      @content;\n    }\n  }\n  @if ($breakpoint == $sm) {\n    /* \n    ##Device = Low Resolution Tablets, Mobiles (Landscape)\n    ##Screen = B/w 481px to 767px\n  */\n    @media only screen and (min-width: 480px) and (max-width: 767px) {\n      @content;\n    }\n  }\n  @if ($breakpoint == $md) {\n    /* \n    ##Device = Tablets, Ipads (landscape)\n    ##Screen = B/w 768px to 991px\n  */\n    @media only screen and (min-width: 768px) and (max-width: 991px) {\n      @content;\n    }\n  }\n  @if ($breakpoint == $lg) {\n    /* \n    ##Device = Tablets, Ipads (portrait)\n    ##Screen = B/w 992px to 1199px\n  */\n    @media only screen and (min-width: 992px) and (max-width: 1199px) {\n      @content;\n    }\n  }\n  @if ($breakpoint == $xl) {\n    /* \n    ##Device = Laptops\n    ##Screen = Below 1200px\n  */\n    @media only screen and (min-width: 1200px) {\n      @content;\n    }\n  }\n  @if ($breakpoint == $xxl) {\n    /* \n    ##Device = Laptops, Desktops\n    ##Screen = abouve 1280px\n  */\n    @media only screen and (min-width: 2560px) {\n      @content;\n    }\n  }\n}\n\n@import \"./Components/Carousel/carousel.scss\";\n@import \"./Sections/HomePage/CustomerAndPartners/customersAndPartners.scss\";\n@import \"./Components/Flag/flag.scss\";\n@import \"./Components/Layouts/Header/header.scss\";\n@import \"./Sections/HomePage/Insights/insights.scss\";\n@import \"./Components/InsightsCards/insightsCards.scss\";\n@import \"./Sections/HomePage/Intro/intro.scss\";\n@import \"./Sections/HomePage/Industries/industries.scss\";\n\n@import \"./Components/Card/serviceCard.scss\";\n\n@import \"../src/Components/OurCustomer/ourCustomers.scss\";\n@import \"../src/Components/OurPartners/ourPartners.scss\";\n@import \"../src/Components/HerosImages/heroImages.scss\";\n\n.commonListStyle {\n  margin-bottom: 1.1vh;\n  padding: 0;\n  padding-left: 1vw !important;\n  @media (max-width: 1024px) {\n    padding-left: 2.5vw !important;\n  }\n}\n\n.commonListStyle li {\n  line-height: 150%;\n}\n\n.commonTitleHead {\n  color: #fff;\n  font-size: 5.1vh;\n  font-weight: 700;\n  line-height: 150%;\n  z-index: 100;\n  margin: 15vh 0 8.4vh 0;\n  text-align: center;\n  @media (max-width: 1024px) {\n    font-size: 2.6rem;\n    margin: 8.4vh 0 4.2vh 0;\n  }\n  @media (max-width: 575px) {\n    font-size: 1.6rem;\n  }\n}\n\n.headingTextMain {\n  color: #fff;\n  font-size: 5.1vh;\n  font-weight: 700;\n  line-height: 150%;\n  @media (max-width: 1024px) {\n    font-size: 2.6rem;\n  }\n  @media (max-width: 575px) {\n    font-size: 1.6rem;\n  }\n}\n\n.subHeadTextMain {\n  color: #fff;\n  font-size: 1.5vw;\n  line-height: 150%;\n  @media (max-width: 1024px) {\n    font-size: 1.8rem;\n  }\n  @media (max-width: 575px) {\n    font-size: 1.2rem;\n  }\n}\n\n.paragraphText {\n  color: #fff;\n  font-size: 1.6vw;\n  width: 100%;\n  line-height: 150%;\n\n  @media (max-width: 1024px) {\n    font-size: 1.5rem;\n  }\n  @media (max-width: 575px) {\n    font-size: 1rem;\n  }\n}\n",".ocp {\n  background: #1d1a36;\n  display: flex;\n  align-items: center !important;\n}\n\n.ocp-center {\n  display: flex;\n  justify-content: center;\n  align-items: center !important;\n  height: 100%;\n}\n\n.ocp-main-row {\n  width: 90vw;\n}\n\n.ocp-orange-gradient {\n  position: absolute;\n  z-index: 1;\n  right: 0;\n  width: 665px;\n  height: 577px;\n  border-radius: 665px;\n  opacity: 0.5;\n  background: rgba(240, 89, 42, 0.4);\n  filter: blur(150px);\n}\n\n.ocp-logo-div {\n  background: #ffffff;\n  border-radius: 4rem;\n  padding: 5rem 3rem;\n  width: 100%;\n  z-index: 2;\n}\n\n.tab-title {\n  color: #000;\n  font-size: 3.5vw;\n  margin-bottom: 3.3vh;\n  text-align: center;\n}\n\n.tab-text {\n  color: #000;\n  font-size: 1.4vw;\n  font-weight: 400;\n  text-align: center;\n  line-height: 150%;\n}\n\n.ocp-main-title {\n  font-size: 5.1vh;\n  font-weight: 700;\n  color: #ffffff !important;\n}\n\n.cpTabImage {\n  min-width: 16vw;\n  @media (max-width: 990px){\n    min-width: 40vw;\n  }\n  @media (max-width: 600px) {\n    min-width: 30vw;\n  }\n}\n\n@media (max-width: 990px) {\n  .ocp-main-title {\n    text-align: center;\n    font-size: 2.6rem;\n  }\n\n  .tab-title {\n    font-size: 1.8rem;\n    text-align: center;\n    padding-right: 0;\n    margin-bottom: 12px;\n  }\n\n  .tab-text {\n    text-align: center;\n    font-size: 1.25rem;\n  }\n\n  .ocp-logo-div {\n    padding: 2rem;\n    border-radius: 2rem;\n  }\n\n  .ocp-orange-gradient {\n    display: none;\n  }\n\n  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,\n  .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {\n    max-width: 80vw !important;\n    overflow-x: auto !important;\n    &::-webkit-scrollbar {\n      height: 8px;\n      background: transparent;\n      margin-right: 4px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: rgba(0, 0, 0, 0.2);\n      border-radius: 8px;\n    }\n  }\n\n  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-more,\n  .ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more {\n    display: none;\n  }\n}\n\n// .ant-tabs-top > .ant-tabs-nav {\n//   margin: 0 0 5vh 0;\n// }\n\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-list {\n  max-width: 80vw !important;\n  overflow-x: auto !important;\n  &::-webkit-scrollbar {\n    height: 0px;\n    background: transparent;\n    margin-right: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    // background: transparent;\n    border-radius: 8px;\n  }\n}\n\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-more,\n.ant-tabs > div > .ant-tabs-nav .ant-tabs-nav-more {\n  display: none;\n}\n\n.ant-tabs-nav-wrap {\n  justify-content: center;\n}\n\n.ocp-tab.ant-tabs .ant-tabs-tab + .ant-tabs-tab {\n  margin: 0;\n}\n\n.ocp-tab .ant-tabs-tab {\n  filter: grayscale(100%);\n  border-bottom: 2px solid #bab8b8 !important;\n  opacity: 0.5;\n}\n\n.ocp-tab .ant-tabs-tab-active {\n  filter: none;\n  opacity: 1;\n}\n\n.ocp-tab .ant-tabs-ink-bar::after {\n  background: #f0592a !important;\n  height: 5px !important;\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n",".flag {\n  background-color: #f0592a;\n  margin-right: 18%;\n  position: relative;\n  font-weight: 700;\n\n  padding: 20px;\n  color: #fff;\n}\n\n.flag:before,\n.flag:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 100%;\n  width: 50px;\n  height: 50%;\n  background-image: linear-gradient(to left top, transparent 50%, #f0592a 50%);\n}\n\n.flag:after {\n  top: 50%;\n  transform: scaleY(-1);\n}\n\n.heading-title {\n  color: white !important;\n}\n",".infoRow {\n  display: flex;\n  align-items: center;\n  height: 10vh;\n  background: #1d1a36;\n  border-bottom: 1px solid #00000024;\n  overflow: hidden;\n}\n\n.infoColImage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 1rem;\n}\n\n.menuColStyle {\n  background-color: transparent;\n  font-size: 1.2rem;\n  justify-content: flex-end;\n}\n\n.drawerMenuData {\n  min-height: 50vh;\n  background-color: #010A29;\n  padding: 1rem 1rem 2rem .5rem;\n}\n\n.drawerMenuDataMobile {\n  padding: 0rem 1rem 2rem .5rem;\n}\n\n.headerDrawerData {\n  height: 100%;\n}\n\n.headerDrawerData h4 {\n  color: #eb5a25;\n  font-weight: bolder;\n  margin-bottom: 1.5rem;\n}\n\n.headerDrawerData h5 {\n  color: #FFF;\n  margin-top: 1rem;\n}\n\n.headerDrawerData h6 {\n  color: rgb(200, 200, 200);\n  ;\n  // font-style: italic;\n}\n\n.headerDrawerDataDesktop {\n  padding: 1rem;\n}\n\n.headerDrawer .ant-drawer-body {\n  padding: 0 !important;\n}\n\n.headerDrawer h6:hover,\n.headerDrawer h5:hover {\n  color: #eb5a25;\n  cursor: pointer;\n}\n\n\n.ant-menu-submenu-popup {\n  div {\n    background-color: #1d1a36 !important;\n    color: #FFF !important;\n  }\n\n  color: #FFF !important;\n}\n\n.headerMenu {\n  color: #eb5a25 !important;\n}\n\n\n/* Underline on hover */\n.menuColStyle.ant-menu-horizontal>.ant-menu-submenu:hover::after {\n  border-bottom: 2px solid #ffb8b9 !important;\n}\n\n/* Underline when submenu is open */\n.menuColStyle.ant-menu-horizontal>.ant-menu-submenu-open::after {\n  border-bottom: 2px solid #ffb8b9 !important;\n}\n\n/* Underline when submenu is selected (child Menu.Item is in selectedKeys) */\n.menuColStyle.ant-menu-horizontal>.ant-menu-submenu-selected::after {\n  border-bottom: 2px solid #ff4d4f !important;\n}\n\n/* Optional transition */\n.menuColStyle.ant-menu-horizontal>.ant-menu-submenu::after {\n  transition: border-bottom 0.3s ease;\n}\n\n.header-custom-tabs .ant-tabs-nav {\n  background-color: rgba(255, 255, 255, 0.01);\n  height: 100% !important;\n  min-height: 50vh;\n  min-width: 20vw;\n}\n\n.header-custom-tabs .ant-tabs-tab {\n  color: white !important;\n  transition: all 0.3s;\n  // font-size: 1rem;\n  font-size: large;\n\n}\n\n.header-custom-tabs .ant-tabs-tab-active {\n  border-left: .2rem solid #eb5a25;\n  border-right: none !important;\n  color: #FFF !important;\n  background: linear-gradient(90deg, #261729 0%, #261b2f 50%, #272237 100%);\n\n\n}\n\n/* Remove active tab line */\n.header-custom-tabs .ant-tabs-ink-bar {\n  display: none !important;\n}\n\n\n.headerDrawerDataDesktop {\n  h4 {\n    font-weight: 300;\n  }\n\n  h6 {\n    color: #FFF !important;\n  }\n\n  span {\n    color: rgb(200, 200, 200);\n    font-weight: 300;\n  }\n}\n\n\n/* Base menu item style */\n// .mobile-menu .ant-menu-item {\n//   color: white !important;\n//   background-color: transparent !important;\n// }\n\n/* When hovered or focused */\n\n.mobile-menu .ant-menu-title-content {\n  // color: #FFF !important;\n}\n\n.mobile-menu .ant-menu-item-active {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  color: #eb5a25 !important;\n  /* Optional hover text color */\n}\n\n/* When selected */\n.mobile-menu .ant-menu-item-selected {\n  // background-color: #eb5a25 !important; /* Red background */\n  color: #eb5a25 !important;\n  /* White text */\n  // font-weight: bold;\n  background-color: transparent !important;\n}",".container-fluid {\n  width: 80%;\n}\n\n.insights {\n  padding: 4rem;\n  background: #ffffff;\n  width: 50%;\n  height: 90vh;\n}\n\n.insights-main-row {\n  display: flex;\n  justify-content: left;\n}\n\n.insights-cards {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n@include respond($lg) {\n  .insights {\n    margin-top: 2rem;\n    padding-left: 4rem !important;\n    background: #ffffff;\n  }\n}\n\n@include respond($xl) {\n  .insights {\n    margin-top: 2rem;\n    padding-left: 4rem !important;\n    margin-bottom: 2rem;\n    background: #ffffff;\n  }\n}\n\n@include respond($xxl) {\n  .insights {\n    margin-top: 2rem;\n    padding-left: 4rem !important;\n    margin-bottom: 2rem;\n    background: #ffffff;\n  }\n}\n\n@media (max-width: 1070px) {\n  .insights {\n    height: 120vh;\n  }\n}\n\n@media (max-width: 768px) {\n  .insights {\n    height: 150vh;\n  }\n}\n\n@media (max-width: 585px) {\n  .insights {\n    height: 200vh;\n  }\n}\n\n@media (max-width: 375px) {\n  .insights {\n    height: 220vh;\n  }\n}",".insightsCard {\n    height: 200px;\n    width: 400px;\n    background: #253C77;\n    line-height: 1.2 !important;\n    padding: 4% !important;\n    border-radius: 0 !important;\n}\n\n.insightsCard .ant-card-body  {\n  padding: 0 !important;\n}\n\n.redirectIcon {\n    position: absolute;\n    top: 85%;\n    color: white;\n}\n\n.arrow-outlined {\n    position: absolute;\n    top: 80%;\n    color: white;\n    outline: solid;\n    font-size: 20px;\n    padding: 5px;\n    cursor: pointer;\n}\n\n.insightsCard:hover {\n    height: 200px;\n    width: 400px;\n    background: #3B5085;\n    cursor: pointer;\n}\n\n.insights-card-text {\n    position: relative;\n    color: #ffffff;\n    padding: 2% 2% !important;\n    line-height: 1.2 !important;\n}\n\n@media (max-width: 585px) {\n    .insightsCard {\n        height: 280px;\n    }\n\n    .insightsCard:hover {\n        height: 280px;\n    }\n\n}",".homeButton {\n  margin-top: 4%;\n}\n\n.homePageIntro {\n  margin-bottom: 5rem;\n}\n\n.intro-anchor {\n  color: #fff;\n  text-decoration: none;\n}\n\n.youtube-thumbnail {\n  width: 100%;\n}\n\n.youtube-thumbnail-card {\n  display: flex;\n  justify-content: center;\n  padding: none;\n  border: 0;\n  cursor: pointer;\n  background-image: url(\"../../../assets/images/youtube/youtube-video-thumbnail.webp\");\n  background-size: cover;\n  animation: slide-in 0.5s ease-in-out;\n}\n\n@keyframes slide-in {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n.youtube-thumbnail-card:hover {\n  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.19);\n  transition: opacity 3s ease-in-out;\n  border: 1px solid #00000024;\n}\n\n.homePageIntro .overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n.popup {\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  background-color: rgba(255, 255, 255, 1);\n  border-radius: 15px;\n  padding: 45px 0 45px 45px;\n  top: 50%;\n  left: 50%;\n  width: 600px;\n  height: 450px;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n}\n\n.popupCancelBtn {\n  border-radius: 100%;\n  border: 1px solid #253c77;\n  top: -11%;\n  width: 45px;\n  height: 45px;\n  padding: 0;\n}\n\n.popupCancelBtnIcon {\n  font-size: 25px;\n  color: #253c77;\n}\n\n@include respond($xs) {\n  .homePageTitle {\n    color: #253c77 !important;\n  }\n\n  .homePageIntro {\n    padding: 2rem 2rem 2rem 2rem;\n    min-height: 300px;\n    height: auto;\n  }\n\n  .numberAnimation {\n    margin-top: 2rem;\n    display: flex;\n    justify-content: center;\n    .fortuneClientStaticText {\n      margin-top: 1rem !important;\n    }\n  }\n\n  .Arrows {\n    position: absolute;\n    left: 79%;\n    top: 25%;\n  }\n}\n\n@include respond($sm) {\n  .homePageTitle {\n    color: #253c77 !important;\n  }\n\n  .homePageIntro {\n    padding: 1rem 2rem 1rem 2rem;\n    min-height: 300px;\n    height: auto;\n  }\n\n  .numberAnimation {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: center;\n    .fortuneClientStaticText {\n      margin-top: 1rem !important;\n    }\n  }\n\n  .youtube-thumbnail-card {\n    width: 50%;\n  }\n\n  .Arrows {\n    position: absolute;\n    left: 79%;\n    top: 25%;\n  }\n}\n\n@include respond($md) {\n  .homePageTitle {\n    color: #253c77 !important;\n  }\n\n  .homePageIntro {\n    padding: 3rem 4rem 3rem 4rem;\n    min-height: 300px;\n    height: auto;\n  }\n\n  .youtube-thumbnail-card {\n    width: 50%;\n  }\n\n  .numberAnimation {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: center;\n    .fortuneClientStaticText {\n      margin-top: 1rem !important;\n    }\n  }\n\n  .Arrows {\n    position: absolute;\n    left: 88%;\n    top: 25%;\n  }\n}\n\n@include respond($lg) {\n  .homePageTitle {\n    color: #253c77 !important;\n  }\n\n  .homePageIntro {\n    padding: 3rem 4rem 3rem 4rem;\n    min-height: 300px;\n    height: auto;\n  }\n\n  .numberAnimation {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: center;\n    .fortuneClientStaticText {\n      margin-top: 1rem !important;\n    }\n  }\n\n  .Arrows {\n    position: absolute;\n    left: 88%;\n    top: 25%;\n  }\n}\n\n@include respond($xl) {\n  .homePageTitle {\n    color: #253c77 !important;\n  }\n\n  .homePageIntro {\n    padding: 4rem 4rem 4rem 4rem;\n    min-height: 300px;\n    height: auto;\n  }\n\n  .numberAnimation {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: center;\n    .fortuneClientStaticText {\n      margin-top: 1rem !important;\n    }\n  }\n\n  .Arrows {\n    position: absolute;\n    left: 85%;\n    top: 25%;\n  }\n}\n\n@include respond($xxl) {\n  .homePageTitle {\n    color: #253c77 !important;\n  }\n\n  .homePageIntro {\n    left: 5%;\n    padding: 4rem 4rem 4rem 4rem;\n    min-height: 300px;\n    height: auto;\n  }\n\n  .numberAnimation {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: center;\n    .fortuneClientStaticText {\n      margin-top: 1rem !important;\n    }\n  }\n\n  .Arrows {\n    position: absolute;\n    left: 88%;\n    top: 25%;\n  }\n}\n\n@media (max-width: 625px) {\n  .popup {\n    display: flex;\n    justify-content: center;\n    position: fixed;\n    background-color: rgba(255, 255, 255, 1);\n    padding: 30px 0 30px 30px;\n    top: 50%;\n    left: 50%;\n    width: 350px;\n    height: 250px;\n    transform: translate(-50%, -50%);\n    z-index: 1000;\n  }\n\n  .popupCancelBtn {\n    border-radius: 100%;\n    border: 1px solid #253c77;\n    top: -14%;\n    width: 30px;\n    height: 30px;\n    padding: 0;\n  }\n\n  .popupCancelBtnIcon {\n    font-size: 25px;\n    color: #253c77;\n  }\n}\n\n@media (max-width: 375px) {\n  .popup {\n    display: flex;\n    justify-content: center;\n    position: fixed;\n    background-color: rgba(255, 255, 255, 1);\n    padding: 30px 0 30px 30px;\n    top: 50%;\n    left: 50%;\n    width: 300px;\n    height: 200px;\n    transform: translate(-50%, -50%);\n    z-index: 1000;\n  }\n\n  .popupCancelBtn {\n    border-radius: 100%;\n    border: 1px solid #253c77;\n    top: -14%;\n    width: 30px;\n    height: 30px;\n    padding: 0;\n  }\n\n  .popupCancelBtnIcon {\n    font-size: 25px;\n    color: #253c77;\n  }\n}\n",".industries-section {\n  background: transparent;\n  margin-top: 7.5rem;\n}\n\n.industries-main-row {\n  width: 100%;\n  padding: 0 5rem;\n}\n\n.container-industries h2 {\n  color: #fff;\n  text-align: center;\n  font-size: 5.1vh;\n  font-weight: 700;\n  margin-bottom: 3.75rem;\n}\n\n.container-industries h3 {\n  color: #fff;\n  font-size: 5.1vh;\n  font-weight: 400;\n  margin-bottom: 1.25rem;\n}\n\n.container-industries h4 {\n  color: #fff;\n  font-size: 1.3vw;\n  font-weight: 700;\n  margin-bottom: 4rem;\n}\n\n.container-industries span {\n  color: #fff;\n  line-height: 150%;\n  font-size: 1.35vw;\n}\n\n.industries-industoryBox {\n  display: flex;\n  justify-content: center;\n  margin: 3.75rem 0 7.5rem 0;\n  z-index: 2;\n}\n\n@media (max-width: 992px) {\n  .industries-main-row {\n    padding: 0 1rem;\n  }\n\n  .container-industries h2 {\n    margin-bottom: 1rem;\n    font-size: 2.6rem;\n  }\n\n  .container-industries h3 {\n    font-size: 2.6rem;\n  }\n\n  .container-industries h4 {\n    text-align: center;\n    margin-bottom: 2rem;\n    font-size: 1.25rem;\n  }\n\n  .container-industries span {\n    font-size: 1.125rem;\n  }\n}\n\n@media (min-width: 1400px) {\n  .industory-box {\n    width: 20vh;\n    height: 20vh;\n  }\n  .industory-box span {\n    text-align: center;\n    font-size: 2vh;\n  }\n}\n\n@media (max-width: 575px) {\n  .container-industries h2 {\n    font-size: 1.6rem;\n  }\n\n  .container-industries h3 {\n    font-size: 1.6rem;\n  }\n\n  .container-industries span {\n    font-size: 1rem;\n  }\n}\n",".valueCardText {\n  text-align: center;\n}\n\n@include respond($xxl) {\n  .defaultCard {\n    background: #0a2c51 !important;\n    min-height: 175px;\n    width: 200px;\n    height: auto;\n    width: auto;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #f0592a;\n  }\n\n  .defaultCard:hover {\n    background: #253c77 !important;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #fff;\n  }\n\n  .rightArrow {\n    position: absolute;\n    top: 85%;\n    left: 90%;\n    color: white;\n  }\n\n  .serviceIcon {\n    height: 50px;\n    width: 50px;\n  }\n\n  .cardText {\n    color: white;\n  }\n}\n\n@include respond($xl) {\n  .defaultCard {\n    background: #0a2c51 !important;\n    width: 300px;\n    height: 250px;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #f0592a;\n    margin-left: .2rem;\n  }\n\n  .defaultCard:hover {\n    background: #253c77 !important;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #fff;\n  }\n\n  .rightArrow {\n    position: absolute;\n    top: 85%;\n    left: 90%;\n    color: white;\n  }\n\n  .serviceIcon {\n    height: 50px;\n    width: 50px;\n  }\n\n  .cardText {\n    color: white;\n  }\n}\n\n@include respond($lg) {\n  .defaultCard {\n    background: #0a2c51 !important;\n    min-height: 175px;\n    width: 200px;\n    height: auto;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #f0592a;\n  }\n\n  .defaultCard:hover {\n    background: #253c77 !important;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #fff;\n  }\n\n  .rightArrow {\n    position: absolute;\n    top: 85%;\n    left: 90%;\n    color: white;\n  }\n\n  .serviceIcon {\n    height: 50px;\n    width: 50px;\n  }\n\n  .cardText {\n    color: white;\n  }\n}\n\n@include respond($md) {\n  .defaultCard {\n    background: #0a2c51 !important;\n    min-height: 175px;\n    width: 200px;\n    height: auto;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #f0592a;\n  }\n\n  .defaultCard:hover {\n    background: #253c77 !important;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #fff;\n  }\n\n  .rightArrow {\n    position: absolute;\n    top: 85%;\n    left: 90%;\n    color: white;\n  }\n\n  .serviceIcon {\n    height: 50px;\n    width: 50px;\n  }\n\n  .cardText {\n    color: white;\n  }\n}\n\n@include respond($sm) {\n  .defaultCard {\n    background: #0a2c51 !important;\n    min-height: 175px;\n    width: 200px;\n    height: auto;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #f0592a;\n  }\n\n  .defaultCard:hover {\n    background: #253c77 !important;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #fff;\n  }\n\n  .rightArrow {\n    position: absolute;\n    top: 85%;\n    left: 90%;\n    color: white;\n  }\n\n  .serviceIcon {\n    height: 50px;\n    width: 50px;\n  }\n\n  .cardText {\n    color: white;\n  }\n}\n\n@include respond($xs) {\n  .defaultCard {\n    background: #0a2c51 !important;\n    min-height: 175px;\n    width: 200px;\n    height: auto;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #f0592a;\n  }\n\n  .defaultCard:hover {\n    background: #253c77 !important;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #fff;\n  }\n\n  .rightArrow {\n    position: absolute;\n    top: 85%;\n    left: 90%;\n    color: white;\n  }\n\n  .serviceIcon {\n    height: 50px;\n    width: 50px;\n  }\n\n  .cardText {\n    color: white;\n  }\n}\n\n@include respond($xxs) {\n  .defaultCard {\n    background: #0a2c51 !important;\n    min-height: 175px;\n    width: 200px;\n    height: auto;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #f0592a;\n  }\n\n  .defaultCard:hover {\n    background: #253c77 !important;\n    border-radius: 0;\n    position: relative;\n    border-top: 6px solid #fff;\n  }\n\n  .rightArrow {\n    position: absolute;\n    top: 85%;\n    left: 90%;\n    color: white;\n  }\n\n  .serviceIcon {\n    height: 50px;\n    width: 50px;\n  }\n\n  .cardText {\n    color: white;\n  }\n}\n",".ourCustomers {\n  &_div {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    background: #1D1A36;\n    padding: 6vw 0vw;\n\n  }\n\n  &_heading {\n    color: #FFF;\n    font-family: Roboto;\n    font-size: 5.1vh;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 100%;\n    padding-bottom: 3vw;\n  }\n\n  &_card {\n    display: flex;\n    justify-content: center;\n    width: 75vw;\n    border-radius: 32.25px;\n    padding:4vw;\n    background: linear-gradient(137deg, rgba(255, 182, 160, 0.20) 0%, rgba(240, 89, 42, 0.20) 18.54%, rgba(37, 60, 119, 0.20) 100%);\n  }\n\n  &_img {\n    width: 100%;\n    justify-content: center;\n  }\n\n  &_col {\n    width: 100%;\n    display: flex;\n    align-self: center;\n    justify-content: center;\n  }\n}\n\n.content {\n  width: 100%;\n}\n\n.ourCustomersimageDiv {\n  height: 30vh;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n\n@media only screen and (max-width: 579px) {\n  .ourCustomers {\n    &_heading {\n      padding-bottom: 6vw;\n      font-size: 5vw;\n    }\n\n    &_img {\n      width: 50vw;\n    }\n    &_card {      padding:10vw;\n      border-radius: 10px;\n    }\n    &_div {\n      padding: 16vw 0vw 0vw;\n  \n    }\n  }\n}\n\n@media only screen and (min-width: 579px) and (max-width: 721px) {\n  .ourCustomers {\n    &_heading {\n      font-size: 5vw;\n    }\n\n    &_img {\n      width: 28vw;\n    }\n\n    &_card {\n      padding:10vw;\n      width: 80vw;\n    }\n  }\n}\n\n@media only screen and (min-width: 721px) and (max-width: 1388px) {\n  .ourCustomers {\n    &_heading {\n      font-size: 5.1vh;\n    }\n\n    &_card {\n      width: 85vw;\n    }\n\n    &_img {\n      width: 23vw;\n    }\n  }\n}\n@media only screen and (min-width: 1388px) and (max-width: 2561px) {\n  .ourCustomers {\n    &_heading {\n      font-size: 5.1vh;\n    }\n\n    &_card {\n      width: 80vw;\n    }\n\n    &_img {\n      width: 23vw;\n    }\n  }\n}",".ourPartners {\n  &_div {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    background: #1d1a36;\n    padding: 6vw 0vw;\n  }\n\n  &_heading {\n    color: #fff;\n    font-family: Roboto;\n    font-size: 5.1vh;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 100%;\n    padding-bottom: 3.9vw;\n  }\n\n  &_card {\n    display: flex;\n    justify-content: center;\n    width: 95vw;\n    padding: 4vw 0vw;\n    border-radius: 32.25px;\n    background: linear-gradient(\n      137deg,\n      rgba(255, 182, 160, 0.2) 0%,\n      rgba(240, 89, 42, 0.2) 18.54%,\n      rgba(37, 60, 119, 0.2) 100%\n    );\n  }\n  &_col {\n    margin: 0vw 2vw;\n    width: 100%;\n    display: flex;\n    align-self: center;\n    justify-content: center;\n   \n  }\n  &_img {\n    width: 15vw;\n  }\n}\n@media only screen and (max-width: 601px) {\n  .ourPartners {\n    &_heading {\n      padding-bottom: 6vw;\n      font-size: 6vw;\n    }\n\n    &_img {\n      width: 50vw;\n    }\n    &_card {\n      width: 70vw;\n      padding:10vw;\n      border-radius: 10px;\n    }\n    &_div {\n      padding: 16vw 0vw 0vw;\n  \n    }\n  }\n}\n\n@media only screen and (min-width: 601px) and (max-width: 721px) {\n  .ourPartners {\n    &_heading {\n      font-size: 5vw;\n    }\n\n    &_img {\n      width: 33vw;\n    }\n\n    &_card {\n      width: 80vw;\n    }\n  }\n}\n\n@media only screen and (min-width: 721px) and (max-width: 1026px) {\n  .ourPartners {\n    &_heading {\n      font-size: 3.5vw;\n    }\n\n    &_card {\n      padding: 5vw ;\n      width: 85vw;\n    }\n\n    &_img {\n      width: 23vw;\n    }\n    &_col{\n      margin: 0vw 0vw;\n    }\n    &_div {\n      padding: 7.8vw 0vw 0vw;\n  \n    }\n}\n}\n@media only screen and (min-width: 1026px) and (max-width: 1388px) {\n  .ourPartners {\n    &_heading {\n      font-size: 5.1vh;\n    }\n\n    &_card {\n      padding: 5vw 3vw;\n      width: 90vw;\n    }\n\n    &_img {\n      width: 15vw;\n    }\n    &_col{\n      margin: 0vw 1vw;\n    }\n    &_div {\n      padding: 7.8vw 0vw 0vw;\n  \n    }\n  }\n}\n@media only screen and (min-width: 1388px) and (max-width: 1921px) {\n  .ourPartners {\n    &_heading {\n      font-size: 5.1vh;\n    }\n    &_col{\n      margin: 0vw 1vw;\n    }\n    &_card {\n      padding: 3vw 0vw;\n      width: 90vw;\n    }\n    &_div {\n      padding: 7.8vw 0vw 0vw;\n    }\n    &_img{\n      width: 16vw;\n    }\n  }\n}\n@media only screen and (min-width: 1921px) and (max-width: 2561px) {\n  .ourPartners {\n    &_heading {\n      font-size: 5.1vh;\n    }\n    &_col{\n      margin: 0vw 1vw;\n    }\n    &_card {\n      padding: 3vw 4vw;\n      width: 75vw;\n    }\n\n    &_img {\n      width: 18vw;\n    }\n    &_div {\n      padding: 7.8vw 0vw 0vw;\n  \n    }\n  }\n}",".hero {\n\n    &_image {\n        width: 100%;\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: cover;\n        position: relative;\n        margin-bottom: 2rem;\n\n\n    }\n\n\n    &_text {\n        text-align: center;\n        position: absolute;\n        transform: translate(-50%, -50%);\n        top: 35%;\n        left: 50%;\n        color: #FFFFFF;\n\n    }\n\n    &_subheading {\n        font-family: 'Helvetica';\n        font-weight: 600;\n        font-size: 3vw;\n        color: #F0592A;\n    }\n\n    &_heading {\n        font-weight: bold\n    }\n}\n@media (min-width: 2100px){\n    .hero_image {\n        width: 100%;\n        height:50vh;\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: cover;\n        position: relative;\n        margin-bottom: 2rem;\n\n    }\n    .hero_heading{\n      font-size: 4.5rem;\n    }\n    .hero_subheading {\n        font-size: 3.5rem;\n    }\n  }\n  @media (max-width: 924px) {\n    .hero_image {\n        width: 100%;\n        height:50vh;\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: cover;\n        position: relative;\n        margin-bottom: 2rem;\n\n    }\n    .hero_heading{\n        font-size: 1.6rem;\n    }\n\n    .hero_subheading {\n        font-size: 1.3rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
